import React from 'react'

import './ShowText.css'

export const ShowText = ({label, text}) => {
  return (
    <div className='show-text'>
      <label className='show-text__label'> { label } </label>
      <div className="show-text__data">
        { text }
      </div>
    </div>
  )
}
